import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const SiteAbortApprovalsListFinance = ({
  approvalList,
  getSiteAbortApprovalFinance,
  acceptSiteStatusApproval,
  rejectAbortApproval,
  siteStatusCSV
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  console.log("PAGE::APPROVAL LIST FOR FINANCE");
  useEffect(() => {
    if (getSiteAbortApprovalFinance !== null) {
      (async () => {
        setIsLoading(true);
        await getSiteAbortApprovalFinance();
        setIsLoading(false);
      })();
    }
  }, [getSiteAbortApprovalFinance]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    // console.log(filterData.site_no);
    setFilterData(filterData);
    await getSiteAbortApprovalFinance(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const handleCSV = async() => {
    setIsLoading(true);
    const res = await siteStatusCSV(filterData);
    setIsLoading(false);
    window.open(res.data, '_blank');
  }

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
           onClick={() => handleCSV()}
           className="btn btn-primary"
           >CSV&nbsp;
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
             <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z"/>
           </svg>
        </Button> 
        <Button
            onClick={filterToggle}
            className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
    </Fragment>
    );
  };

  const Headers = [
    'Site No',
    'Site Name',
    'Requested By',
    'Status',
    'Remark',
    'Requested On',
    'Approve',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'site_name',
      'name',
      'statusName',
      'remark',
      'created_at',
    ];

    if (approvalList !== {} && approvalList.data) {
      const data = approvalList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
              {
                'Approve/Reject': '',
               
              }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      setIsLoading(true);
      await acceptSiteStatusApproval(data.actionObj.id).then(async (response) => {
        if (response == true) {
          await getSiteAbortApprovalFinance();
          setIsLoading(false);
          setIsModal(true);
        }
      });
    } else {
      setIsLoading(false);
      setIsModal(true);
    }
    setIsLoading(false);
  };

  const handleModalHide = () => setIsModal(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Button onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getSiteAbortApprovalFinance(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const handleRejection = async (info) => {
    // console.log(info); return false;
    setIsModal(false);
    if (info.action === 'reject') {
      setIsLoading(true);
      await rejectAbortApproval(info.actionObj.id).then(async (response) => {
        if (response) {
          await getSiteAbortApprovalFinance();
          setIsLoading(false);
          setIsSuccessModel(true);
        }
      });
    }
  };

  return (
    <Layout title={localization.siteDismantleLegalApproval} isLoading={isLoading} Buttons={headerBtns}>
      <TableSection
        data={listData}
        headers={Headers}
        detailList={approvalList && approvalList.resultSets}
        onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
        srNo={approvalList?.from}
      />
      {/* {console.log('ddd ' + JSON.stringify(approvalList))} */}
      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={() => setIsModal(false)}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <div className="modal-body">
            <div className="text-center">
              <h5>Are you sure you want to reject?</h5>
              <Button
                className="btn btn-primary mb-4"
                onClick={() => handleRejection(actionData)}
              >
                {localization.continue} <img src={Images?.ArrowRight} alt="" />
              </Button>
              <Button
                onClick={() => setIsModal(false)}
                className="btn btn-transparent"
              >
                {localization.returnToApproval}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </div>
        ) : (
          successIconBox(localization.approvedSuccess, handleModalHide)
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={() => setIsSuccessModel(false)}
      >
        {successIconBox(localization.siteAbortApproval, () =>
          setIsSuccessModel(false)
        )}
      </ModalPop>
      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          siteApprovalFinance={true}
          // listFilterData={filterDropdownList && filterDropdownList.data}
      />
    </Layout>
  );
};

SiteAbortApprovalsListFinance.propTypes = {
  approvalList: PropTypes.any,
  getSiteAbortApprovalFinance: PropTypes.any,
  acceptSiteStatusApproval: PropTypes.any,
  rejectAbortApproval: PropTypes.func,
};

export default SiteAbortApprovalsListFinance;
